import { combineReducers } from 'redux'
import * as actions from '../actions'
import auth from './auth'
import ambassadors from './ambassadors'
import follows from './follows'
import impressions from './impressions'
import location from './location'
import reviews from './reviews'
import users from './users'
import {
  POST_LOCAL_NOTIFICATION,
  REMOVE_LOCAL_NOTIFICATION
} from '../constants/actionTypes'

const appInitialised = (state = false, action) => {
  switch (action.type) {
    case actions.APP_INITIALISED:
      return true
    default:
      return state
  }
}
const country = (state = 'The World', action) => {
  const { type, value } = action

  switch (type) {
    case actions.CHANGE_COUNTRY:
      return value
    default:
      return state
  }
}

const localNotification = (state = '', action) => {
  switch (action.type) {
    case POST_LOCAL_NOTIFICATION:
      return action.message
    case REMOVE_LOCAL_NOTIFICATION:
      return ''
    default:
      return state
  }
}

const position = (
  state = {
    isLoading: false,
    latitude: null,
    longitude: null,
    denied: false,
    code: 0,
    fetched: false
  },
  action
) => {
  switch (action.type) {
    case actions.ASKING_FOR_POSITION:
      return {
        ...state,
        isLoading: true,
        denied: false
      }
    case actions.RECEIVED_POSITION:
      return {
        ...state,
        latitude: action.latitude,
        longitude: action.longitude,
        denied: false,
        isLoading: false,
        fetched: true
      }
    case actions.GET_POSITION_DENIED:
      return {
        ...state,
        denied: true,
        code: action.code,
        isLoading: false
      }
    default:
      return state
  }
}

const combined = combineReducers({
  appInitialised,
  country,
  localNotification,
  position,
  auth,
  ambassadors,
  impressions,
  reviews,
  users,
  location,
  follows
})

export default combined
